import { TOGGLE_MENU } from '../constants/actions';

export function toggleMenu() {
  return dispatch => {
    // Stringify the uuid array.
    dispatch({ type: TOGGLE_MENU });
  }
}
